import { FiSearch, FiX } from 'react-icons/fi';
import { FILTERS, ACTIONS } from '../../constants/labels';
import styles from './Payments.module.css';

export default function PaymentsFilters({
  years, categories,
  filterYear, filterCat, filterSearch, filterFromDate, filterToDate,
  minDate, maxDate, onYearChange, onCatChange, onSearchChange, onFromDateChange, onToDateChange,
  onClearFilters,
}) {
  return (
    <div className={styles.filterRow}>
      <div className="form-group">
        <label>Financial Year</label>
        <select value={filterYear} onChange={(e) => onYearChange(e.target.value)}>
          <option value="">{FILTERS.allYears}</option>
          {years.map((y) => <option key={y.id} value={y.id}>{y.yearLabel}</option>)}
        </select>
      </div>

      <div className="form-group">
        <label>Category</label>
        <select value={filterCat} onChange={(e) => onCatChange(e.target.value)}>
          <option value="">{FILTERS.allCategories}</option>
          {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>

      <div className="form-group">
        <label>Search</label>
        <div style={{ position: 'relative' }}>
          <FiSearch style={{
            position: 'absolute', left: 9, top: '50%',
            transform: 'translateY(-50%)',
            color: 'var(--color-text-muted)', pointerEvents: 'none',
          }} />
          <input
            value={filterSearch}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Voucher no, payee, narration…"
            style={{ paddingLeft: 30 }}
          />
        </div>
      </div>

      <div className="form-group">
        <label>From Date</label>
        <input
          type="date"
          value={filterFromDate}
          min={minDate || undefined}
          max={filterToDate || maxDate || undefined}
          onChange={(e) => onFromDateChange(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>To Date</label>
        <input
          type="date"
          value={filterToDate}
          min={filterFromDate || minDate || undefined}
          max={maxDate || undefined}
          onChange={(e) => onToDateChange(e.target.value)}
        />
      </div>

      <div className="form-group" style={{ alignSelf: 'flex-end' }}>
        <button className="btn btn-ghost btn-sm" onClick={onClearFilters} title={ACTIONS.clearFilters}>
          <FiX /> {ACTIONS.clearFilters}
        </button>
      </div>
    </div>
  );
}
